import type { IReview, ReviewWithSearchableFields } from "@/reviews/review";

/**
 * Computes a searchable attribution string from technicians array
 */
const getSearchableAttribution = (review: IReview): string => {
  const technicians = review.technicians;
  if (!technicians || technicians.length === 0) return "";

  return technicians
    .map((t) => t.display_identification)
    .filter(Boolean)
    .join(" ")
    .trim()
    .toLowerCase();
};

/**
 * Enriches a review with computed searchable fields
 */
export const getEnrichedReview = (
  review: IReview,
): ReviewWithSearchableFields => ({
  ...review,
  searchable_attribution: getSearchableAttribution(review),
});

/**
 * Normalizes a rating value to a valid number between 0 and 5
 * @param rawRating - The raw rating value (may be invalid or out of range)
 * @returns A normalized rating between 0 and 5, or 0 if invalid
 */
export const normalizeRating = (rawRating: number): number =>
  typeof rawRating === "number" && !isNaN(rawRating)
    ? Math.max(0, Math.min(5, Math.round(rawRating)))
    : 0;
